'use strict';

var toConsumableArray = require('../../../@babel/runtime/helpers/esm/toConsumableArray.js');
var _extends = require('../../../@babel/runtime/helpers/esm/extends.js');
var PropTypes = require('prop-types');
var merge = require('./merge.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}

function css(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var output = styleFunction(props);

    if (props.css) {
      return _extends(_extends({}, merge(output, styleFunction(_extends({
        theme: props.theme
      }, props.css)))), omit(props.css, [styleFunction.filterProps]));
    }

    return output;
  };

  newStyleFunction.propTypes = process.env.NODE_ENV !== 'production' ? _extends(_extends({}, styleFunction.propTypes), {}, {
    css: PropTypes__default["default"].object
  }) : {};
  newStyleFunction.filterProps = ['css'].concat(toConsumableArray(styleFunction.filterProps));
  return newStyleFunction;
}

module.exports = css;
